import loadAuthenticationModule from './modules/Authentication.module';
import loadBasketModule from './modules/Basket.module';
import loadCheckoutModule from './modules/Checkout.module';
import loadCookieConsentModule from './modules/CookieConsent.module';
import loadSearchModule from './modules/Search.module';
import loadSessionModule from './modules/Session.module';
import loadUrlModule from './modules/Url.module';
import loadWishListModule from './modules/WishList.module';
const loadHeaderModule = () => ({
    hasRouter: false,
    modules: [
        loadWishListModule(),
        loadBasketModule(),
        loadCheckoutModule(),
        loadSessionModule(),
        loadAuthenticationModule(),
        loadSearchModule(),
        loadUrlModule(),
        loadCookieConsentModule(),
    ],
});
export default loadHeaderModule;
